module.exports = __webpack_public_path__ + "static/media/busstop.55163c0c.svg";